import React from 'react'
import cx from 'classnames'
import Skeleton from 'react-loading-skeleton'

import styles from './Card.module.scss'

const fakeArray = [...Array(5).fill(Math.random())]

export const CardSkeleton: React.FC = () => {
  return (
    <div className={styles.root}>
      <div>
        <div className={styles.label}>
          <Skeleton />
        </div>

        <Skeleton className={styles.price} />

        <div className={styles.list}>
          {fakeArray.map((id) => (
            <Skeleton className={cx(styles.option)} key={id} />
          ))}
        </div>
      </div>

      <Skeleton className={styles.button} />
    </div>
  )
}
